//core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit/src/mapBuilders";
import { NoInfer } from "@reduxjs/toolkit/src/tsHelpers";
import { commonAdminService } from "../../../services/admin/commonAdmin.service";
import { setUser } from "../../common/user";
import {
  setCreateCreativeState,
  setGeneralProgressHide,
  setGeneralProgressShow,
  setGeneralSnackbarState
} from "../../common/ui";

export type CommonAdminSliceState = {
  locales: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
};

const initialState: CommonAdminSliceState = {
  locales: {
    data: null,
    error: null,
    isFetching: false,
  },
};

export const getLocalesData: any = createAsyncThunk(
  'adm/common/getLocalesData',
  async (payload:any, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await commonAdminService.getLocales(payload);
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setGeneralProgressHide());
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());
      return data;
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);

//slice
const commonAdminSlice = createSlice({
  name: 'adm/common',
  initialState: initialState,
  reducers: {
    clearLocalesState(state) {
      state.locales.data = null;
      state.locales.error = null;
      state.locales.isFetching = false;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<CommonAdminSliceState>>) => {
    builder.addCase(getLocalesData.pending, (state ) => {
      state.locales.isFetching = true;
      state.locales.error = null;
    });
    builder.addCase(getLocalesData.fulfilled, (state , action) => {
      state.locales.error = null;
      state.locales.isFetching = false;
      state.locales.data = action.payload;
    });
    builder.addCase(getLocalesData.rejected, (state , action) => {
      state.locales.isFetching = false;
      state.locales.error = action.payload;
    });
  },
});

export default commonAdminSlice.reducer;

export const {
  clearLocalesState,
} = commonAdminSlice.actions;
